import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-flow-action-card',
  imports: [MatIconModule],
  templateUrl: './flow-action-card.component.html',
  styleUrl: './flow-action-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowActionCardComponent {
  readonly icon = input.required<string>();
  readonly iconColor = input.required<string>();
  readonly label = input.required<string>();
}
